module.exports = __webpack_public_path__ + "img/iPad-Landscape@2x.54e18e88.png";